
define('text!modules/targeting/contextual/templates/bin_header.html',[],function () { return '<div class="column header cpm">\n\t<div class="header-c">cpm</div>\n</div>';});

